import { Row, Col, Button, Modal, Typography, Input, Select, Image, Spin } from "antd"
import { prMainLight } from "../../../../themeConfig"
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { prMain } from "../../../../themeConfig";
import { apiApproveScholarship, apiRejectScholarship, apiRejectScholarshipFilesBeneficiary } from '../../../../utils/api'
import { useSelector } from "react-redux";
import isAllowed, { ROLES_DIVISIONS } from '../../../../layout/roles';
import { useState, useEffect } from 'react';
import { useScreenSize } from '../../../../hooks/useScreenSize';


const ScholarshipBeneficiary = ({ detail, scholarship, refresh, setRefresh, loading }) => {

    const { user } = useSelector(state => state.session)
    const { Text } = Typography
    const { TextArea } = Input
    const { width } = useScreenSize()
    const [reason, setReason] = useState()
    const [successModal, setSuccessModal] = useState(false)
    const [openModal, setOpenModal] = useState({ isOpen: false, Option: '' })
    const [details, setDetails] = useState(detail)

    useEffect(() => {
        setDetails(detail)
    },[detail])

    const modalOptions = [
    { label: 'INE (frontal)', value: 'INE-Front' },
    { label: 'INE (trasera)', value: 'INE-Back' },
    { label: 'Comprobante de domicilio', value: 'Address' },
    { label: 'Comprobante de ingresos', value: 'Income' },
    { label: 'Boleta de estudios', value: 'Bolet' },
    { label: 'CURP', value: 'CURP' },
    { label: 'Documento DIF', value: 'Document' },
    ]

    const handleOpen = (open, option) => {
        setSuccessModal(false)
        setOpenModal({ isOpen: open, Option: option })

    }

    const [returnStatus, setReturnStatus] = useState(false)
    const handleCompleteReject = () => {

        try {
            // let folio = details.folioFather
            let curp = details.curpBeneficiary
            let idStatus = openModal.Option === 'unapprove' 
                                ? details.idStatus < 3 
                                    ? 3 
                                    : 2 
                                : 5
            
            setReturnStatus(details.idStatus > 3)
            apiRejectScholarship(curp, idStatus, reason, 1).then(() => {
                if (openModal.Option === 'unapprove' && filesSelected.length !== 0) {
                    let idBeneficiary = details.idBeneficiary
                    let concat = '';
                    for (let i = 0; i < filesSelected.length; i++) {
                        if (filesSelected[i] === "Bolet" && details.scholarshipsFilesList.length > 0) {
                            concat = concat + details.scholarshipsFilesList[0].idFile + ','
                        } else {
                            for (let j = 0; j < scholarship.scholarshipsFiles.length; j++) {
                                if (filesSelected[i] === scholarship.scholarshipsFiles[j].typeDocument) {
                                    concat = concat + scholarship.scholarshipsFiles[j].idFile + ','
                                }
                            }
                        }
                    }
                    if(concat) {
                        apiRejectScholarshipFilesBeneficiary(idBeneficiary, concat.substring(0, concat.length - 1)).then(() => { 
                        }).catch ((e) => {
                            console.log('error',e)
                        })
                    }
                }

                setFilesSelected([])
                setSuccessModal(true)
                setChanged(true)
                setTimeout(() => {
                    setChanged(false)

                }, 2000)
                
            }).catch((e) => {
                console.log(e)

            }).finally(() => {
                setRefresh(!refresh)
            })
        } catch {
            console.log('error')

        }
    }

    const handleCompleteApprove = () => {
        try {
            
            let curp = details.curpBeneficiary
            let idStatus = isAllowed(user, ROLES_DIVISIONS.SCHOLARSHIP_VERIFICATOR) ? 2 : 4
            apiApproveScholarship(curp, idStatus, 1).then((response) => {                
                setRefresh(!refresh)
                setSuccessModal(true)
            }).catch((e) => {
                console.log(e)
            })
        } catch {
            console.log('error')

        }
    }

    const SuccessMessage = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '30vh', }}>
                <CheckCircleOutlined style={modalIcon} />

                <Text style={modalTitle}>Apoyo aprobado.</Text>
                <div style={{ marginTop: '2vh', textAlign: 'center' }}>
                    <Text style={modalText}>Se notificar&aacute; al solicitante que su apoyo ha sido aprobada.</Text>
                </div>
            </div>
        )
    }

    const ApproveModal = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', }}>
                <Text style={modalTitle}>Aprobar apoyo</Text>
                <div style={modalContainer}>

                    <Text style={modalText}>¿Est&aacute; seguro de aprobar este apoyo?</Text>
                    {/* <div style={{ border: `solid 1px ${prMain}`, borderRadius: '16px', fontSize: '16px', textAlign: 'center', marginTop: '2vh' }}>
                        Folio: {details.folio}
                    </div> */}
                </div>
                <div style={modalButtons}>
                    <Button style={rejectButton} onClick={() => handleOpen(false, '')}>Cancelar</Button>
                    <Button type="primary" style={{ color: '#fff' }} onClick={() => handleCompleteApprove()}>Aceptar</Button>
                </div>

            </div>
        )
    }

    const handleChangeReason = (event) => {
        setReason(event.target.value)
    } 

    const [filesSelected, setFilesSelected] = useState([])

    const handleSelect = ( event ) => {
        setFilesSelected(event)
    }

    const [changed, setChanged] = useState(false)
    const RejectModal = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={modalTitle}>
                    { openModal.Option === 'unapprove'
                            ? details.idStatus === 3 
                                ? 'A revisión' 
                                : 'Solicitar cambios'
                            : 'Rechazar apoyo'}
                </Text>
                <div style={modalContainer}>

                    <Text style={modalText}>Especifique la raz&oacute;n a continuaci&oacute;n:</Text>
                    <TextArea style={modalInput} maxLength={255} value={reason} onChange={(e) => handleChangeReason(e)}>
                    </TextArea>

                    { (openModal.Option === 'unapprove' && details.idStatus < 3)
                    &&
                    <>
                    <Text style={modalText}>Seleccione los archivos incorrectos (opcional):</Text>
                    <Select value = {filesSelected} onChange={(e) => handleSelect(e)} mode="multiple" maxTagCount="responsive" style={modalSelect} options={modalOptions} />
                    </>
                    }
                </div>
                <div style={modalButtons}>
                    <Button style={rejectButton} onClick={() => handleOpen(false, '')}>Cancelar</Button>
                    <Button disabled = { !reason } type="primary" style={{ color: '#fff' }} onClick={handleCompleteReject}>Continuar</Button>
                </div>

            </div>
        )
    }

    const RejectMessage = () => {
        
        return (
            <>{
                changed
             ? <div style={{ display: 'flex', flexDirection: 'column', height: '30vh', }}>
                 <div style = {{ margin: 'auto' }}>

                <Spin spinning={changed}>
                </Spin>
                 </div>
             </div>
            : <> {returnStatus
                ? ReturnMessage()
                : <div style={{ display: 'flex', flexDirection: 'column', height: '30vh', }}>
                    <CheckCircleOutlined style={modalIcon} />

                    <Text style={modalTitle}>
                            { openModal.Option === 'unapprove'
                                ? details.idStatus === 2 
                                    ? 'Enviado a revisión' 
                                    : 'Cambios solicitados'
                                : 'Apoyo no aprobado'}
                    </Text>
                    <div style={{ marginTop: '2vh', textAlign: 'center' }}>
                    <Text style={modalText}>{
                        details.idStatus === 2 
                        ? 'Se ha enviado a revisión correctamente'
                        : `Se notificará al solicitante la razón ${openModal.Option === 'unapprove' ? 'para que pueda corregir los datos necesarios.' : 'de rechazo.'}`
                        }</Text>
                    </div>
                </div>} </>
            }</>

        )
    }

    

    const ReturnMessage = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '30vh', }}>
                <CheckCircleOutlined style={modalIcon} />

                <Text style={modalTitle}>Apoyo devuelto.</Text>
                <div style={{ marginTop: '2vh', textAlign: 'center' }}>
                <Text style={modalText}>Se notificar&aacute; al solicitante que su solicitud será revisada nuevamente.</Text>
                </div>
            </div>
        )
    }


    return (
        <div style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto', marginTop: '4vh' }}>
            <Spin spinning={loading}>

          { 
            <div style={buttonsStyle}>
                { ((isAllowed(user, ROLES_DIVISIONS.SCHOLARSHIP_ADMIN) || isAllowed(user, ROLES_DIVISIONS.PURE_ADMIN)) && details.idStatus < 4) &&
                <Button onClick={() => handleOpen(true, 'reject')} type='primary' style={rejectButton} icon={<CloseCircleOutlined style={{ color: prMain }} />} >
                    Rechazar
                </Button>}
               { 
                <Button onClick={() => handleOpen(true, 'unapprove')} type='primary' style={rejectButton} icon={<ExclamationCircleOutlined style={{ color: prMain }} />} >
                    {details.idStatus <= 2 
                        ? 'Solicitar cambios' 
                        : details.idStatus <= 3 
                            ? 'A revision' 
                            : 'Regresar a revisión' }
                </Button>}
                { details.idStatus < 4 && 
                <Button onClick={() => handleOpen(true, 'approve')} type='primary' icon={<CheckCircleOutlined style={{ color: '#fff' }} />} >
                    {isAllowed(user, ROLES_DIVISIONS.SCHOLARSHIP_VERIFICATOR) ? 'A revisión' : 'Aprobar' }
                </Button>}
            </div>}

            <Row style={{ marginTop: '1vh' }}>
                <Col span={24}> 
                    <Row>

                        <Col style={colHeader} span={4}>Nombre</Col>
                        <Col style={colStyle} span={20}>{details.nameBeneficiary} {details.firstLastNameBeneficiary ? details.firstLastNameBeneficiary : ''} {details.secondLastNameBeneficiary ? details.secondLastNameBeneficiary : ''}</Col>

                    </Row>
                </Col>
                <Col span={11}>
                    <Row>
                        <Col style={colHeader} span={8}>{ width > 1200 ? 'Fecha nacimiento' : 'F. Nacim.'}</Col>
                        <Col style={colStyle} span={16}>{details.dateBirth}</Col>
                        <Col style={colHeader} span={8}>CURP</Col>
                        <Col style={colStyle} span={16}>{details.curpBeneficiary}</Col>
                        <Col style={colHeader} span={8}>Edad</Col>
                        <Col style={colStyle} span={16}>{details.ageBeneficiary}</Col>
                        <Col style={colHeader} span={8}>{ width > 1350 ? 'Capac. diferente' : 'Cap. Dif.' }</Col>
                        <Col style={colStyle} span={16}>{details.differentCapacityBeneficiary ? details.differentCapacityBeneficiary : 'Ninguna'}</Col>
                        <Col style={colHeader} span={8}>Tipo apoyo</Col>
                        <Col style={colStyle} span={16}>{details.typeScholarship}</Col>
                    </Row>
                </Col>
                <Col span={11} offset={2}>
                    <Row>
                        <Col style={colHeader} span={8}>Escuela</Col>
                        <Col style={colStyle} span={16}>{details.school}</Col>
                        <Col style={colHeader} span={8}>Nivel Escolar</Col>
                        <Col style={colStyle} span={16}>{details.schoolLevel}</Col>
                        <Col style={colHeader} span={8}>Grado</Col>
                        <Col style={colStyle} span={16}>{details.schoolGrade}</Col>
                        <Col style={colHeader} span={8}>Turno</Col>
                        <Col style={colStyle} span={16}>{details.shift}</Col>
                        <Col style={colHeader} span={8}>{ width > 1200 ? 'Calif. Promedio' : 'Calf. Prom.'}</Col>
                        <Col style={colStyle} span={16}>{details.qualificationAverageBeneficiary}</Col>
                    </Row>
                </Col>
            </Row>
        <Row>
            <Col span={11}>
                <Row>
                <Col style={colHeader} span={8}>{ width > 1200 ? 'Estatus de apoyo' : 'Estatus'}</Col>
                    <Col style={colStyle} span={16}>{details.nameStatus}</Col>
                </Row>
            </Col>
            <Col span={11} offset={2}>
                <Row>
                    <Col style={colHeader} span={8}>Revisado por</Col>
                    <Col style={colStyle} span={16}>{details.scholarshipsObservationList.length !== 0 ? details.scholarshipsObservationList[details.scholarshipsObservationList.length -1].userWhoChangeStatus : ''}</Col>
                </Row>
            </Col>
        </Row>
        <Row>
            <Col span={11}>
            <Row justify="center">
                <div style = {{ width: 'fit-content', marginLeft: 'auto', marginRight: 'auto' }}>
                <label style={{ backgroundColor: prMainLight, borderRadius: '16px 16px 0 0', textAlign: 'center' }} className='input-container' >
                                    Boleta
                                </label>
                                <div style={{ height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    {
                                        details.scholarshipsFilesList[0]
                                            ? <Image id={details.scholarshipsFilesList[0].typeDocument} src={`${details.scholarshipsFilesList[0].url}`} alt={'Boleta'} height={200} style={{ objectFit: 'cover', borderRadius: '0 0 16px 16px' }} />
                                            : <Image
                                                style={{ objectFit: 'cover', borderRadius: '0 0 16px 16px' }}
                                                width={'100%'}
                                                height={200}
                                                src="error"
                                                fallback="data:image/png;base64,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"
                                            />
                                    }
                                    {/* <Button icon={<DeleteFilled />} disabled={state[i] === null} type='link' onClick={() => handleRemoveImage(i)}>Remover</Button> */}
                                </div>
                </div>
            </Row>
            </Col>

            { details.idStatus !== 4 &&
            <Col span = {11} offset={2}>
                

                <Row justify="center">
                    <Col span={18} style={observationHeader} >Observaciones</Col>
                    <Col span={18} style={observationsStyle} >{details.reasonForReject ? details.reasonForReject : 'Ninguna'}</Col>
                </Row>
            </Col>
            }
        </Row>

            <Modal centered
                visible={openModal.isOpen}
                closable={true}
                footer={null}
                destroyOnClose
                onCancel={() => handleOpen(false, '')}>
                <div>


                    {openModal.Option === 'approve'
                        ? successModal
                            ? SuccessMessage()

                            : ApproveModal()
                        : openModal.Option === 'unapprove'
                            ? successModal
                                ? RejectMessage()
                                : RejectModal() 

                            : openModal.Option === 'reject'
                                ? successModal
                                    ? RejectMessage()
                                    : RejectModal()
                                : null
                    }

                </div>
            </Modal>
            </Spin>
        </div>
    )

}

//styles 
const buttonsStyle = {
    width: 'fit-content',
    marginLeft: 'auto',
    marginBottom: '2vh',
    height: 'fit-content',
}

const colHeader = {
    border: 'solid 0px #000',
    height: '30px',
    marginBottom: '15px',
    backgroundColor: prMainLight,
    borderRadius: '100px 0px 0px 100px',
    textAlign: 'center',
    paddingTop: '4px',
    color: '#fff'
}

const observationHeader = {
    border: 'solid 0px #000',
    height: '30px',
    marginBottom: '0px',
    backgroundColor: prMainLight,
    borderRadius: '25px 25px 0px 0px',
    textAlign: 'center',
    paddingTop: '4px',
    color: '#fff'
}

const colStyle = {
    border: `solid 1px ${prMainLight}`,
    height: '30px',
    marginBottom: '15px',
    // backgroundColor: prMainLight,
    borderRadius: '0px 100px 100px 0px',
    paddingLeft: '15px',
    paddingTop: '4px',

}

const observationsStyle = {
    border: `solid 1px ${prMainLight}`,
    height: '200px',
    marginBottom: '15px',
    // backgroundColor: prMainLight,
    borderRadius: '0px 0px 25px 25px',
    padding: '10px 15px',
    textAlign: 'justify',

}

const rejectButton = {
    marginRight: '1vw',
    backgroundColor: '#ffffff00',
    border: `solid 1px ${prMain}`,
    color: prMain
}

const modalTitle = {
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '26px',
}

const modalContainer = {
    minHeight: '10vh',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '2vh',

}

const modalText = {
    marginLeft: 'auto',
    marginRight: 'auto',
}

const modalButtons = {
    marginLeft: 'auto',
    marginTop: '2vh',
    display: 'flex',
    flexDirection: 'row'
}

const modalInput = {
    maxHeight: '10vh',
    height: '10vh',
    marginBottom: '3vh',
}

const modalSelect = {
    width: '100%',
    marginBottom: '2vh'
}

const modalIcon = {
    fontSize: '75px',
    marginBottom: '1vh',
    marginTop: '4vh',
    color: prMain,
}
export default ScholarshipBeneficiary